import { AdminRoleUsersDirectory } from "@/features/admin/components/AdminRoleUsersDirectory";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/admins")({
    component: AdminsUsersPage,
});

function AdminsUsersPage() {
    return (
        <>
            <AdminRoleUsersDirectory role="ADMIN" emptyLabel="admins" />
            <Outlet />
        </>
    );
}
